(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["asset-video-loader"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__assetVideoController) return;
    window.__assetVideoController = true;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function loadSources(video) {
      if (video.dataset.sourcesLoaded === 'true') return;

      const webm = video.dataset.videoWebm;
      const mp4 = video.dataset.videoMp4;

      if (webm) {
        const webmSource = document.createElement('source');
        webmSource.src = webm;
        webmSource.type = 'video/webm';
        video.appendChild(webmSource);
      }

      if (mp4) {
        const mp4Source = document.createElement('source');
        mp4Source.src = mp4;
        mp4Source.type = 'video/mp4';
        video.appendChild(mp4Source);
      }

      video.dataset.sourcesLoaded = 'true';
      video.load();
    }

    function playVideo(video) {
      const promise = video.play();
      if (promise !== undefined) {
        promise
          .then(() => {
            video.classList.add('is-playing');
          })
          .catch(() => {});
      } else {
        video.classList.add('is-playing');
      }
    }

    function pauseVideo(video) {
      video.pause();
      video.classList.remove('is-playing');
    }

    function syncVideo(video, shouldPlay) {
      if (reducedMotion) {
        pauseVideo(video);
        return;
      }

      if (!shouldPlay || document.hidden) {
        pauseVideo(video);
        return;
      }

      loadSources(video);

      if (video.readyState >= 2) {
        playVideo(video);
      } else {
        video.addEventListener('loadeddata', () => playVideo(video), { once: true });
      }
    }

    function observePlayback(video, options) {
      const threshold = options.threshold;
      const rootMargin = options.rootMargin;
      const minRatio = options.minRatio;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const ratioOk = entry.intersectionRatio >= minRatio;
            syncVideo(video, entry.isIntersecting && ratioOk);
          });
        },
        {
          threshold,
          rootMargin,
        }
      );

      observer.observe(video);

      document.addEventListener('visibilitychange', () => {
        const rect = video.getBoundingClientRect();
        const inView = rect.bottom > 0 && rect.top < window.innerHeight;
        syncVideo(video, inView);
      });

      return observer;
    }

    function scheduleDeferred(callback) {
      const run = () => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => callback(), { timeout: 2500 });
        } else {
          setTimeout(callback, 1200);
        }
      };

      if (document.readyState === 'complete') {
        run();
      } else {
        window.addEventListener('load', run, { once: true });
      }
    }

    function bindVideo(video) {
      if (video.dataset.assetVideoBound === 'true') return;
      video.dataset.assetVideoBound = 'true';

      video.controls = false;
      video.removeAttribute('controls');

      if (reducedMotion) {
        video.removeAttribute('autoplay');
        pauseVideo(video);
        return;
      }

      video.setAttribute('autoplay', '');

      const loadMode = video.dataset.assetVideoLoad || 'lazy';

      if (loadMode === 'deferred') {
        scheduleDeferred(() => {
          observePlayback(video, {
            threshold: [0, 0.15, 0.35],
            rootMargin: '0px',
            minRatio: 0.15,
          });

          const rect = video.getBoundingClientRect();
          const inView = rect.bottom > 0 && rect.top < window.innerHeight;
          if (inView) {
            syncVideo(video, true);
          }
        });
        return;
      }

      const isEager = loadMode === 'eager';

      observePlayback(video, {
        threshold: isEager ? [0, 0.1] : [0, 0.2, 0.4],
        rootMargin: isEager ? '80px 0px' : '0px 0px -8% 0px',
        minRatio: isEager ? 0 : 0.2,
      });

      if (isEager) {
        const rect = video.getBoundingClientRect();
        const inView = rect.bottom > 0 && rect.top < window.innerHeight;
        if (inView) {
          syncVideo(video, true);
        }
      }
    }

    function initAssetVideos() {
      document.querySelectorAll('[data-asset-video]').forEach(bindVideo);
    }

    initAssetVideos();
    document.addEventListener('shopify:section:load', initAssetVideos);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer {
    constructor(root) {
      this.root = root;
      this.panel = root.querySelector('[data-cart-drawer-panel]');
      this.body = root.querySelector('[data-cart-drawer-body]');
      this.itemsEl = root.querySelector('[data-cart-drawer-items]');
      this.emptyEl = root.querySelector('[data-cart-drawer-empty]');
      this.footerEl = root.querySelector('[data-cart-drawer-footer]');
      this.countEl = root.querySelector('[data-cart-drawer-count]');
      this.subtotalEl = root.querySelector('[data-cart-drawer-subtotal]');
      this.statusEl = root.querySelector('[data-cart-drawer-status]');
      this.checkoutEl = root.querySelector('[data-cart-drawer-checkout]');
      const placeholderOpen = String.fromCharCode(123, 123);
      const placeholderClose = String.fromCharCode(125, 125);
      this.moneyFormat = root.dataset.moneyFormat || `$${placeholderOpen}amount${placeholderClose}`;
      this.routesRoot = window.Shopify?.routes?.root || '/';
      this.isOpen = false;
      this.lastFocused = null;
      this.statusTimer = null;

      this.strings = {
        countOne: root.dataset.countOne || '1 item',
        countOther: root.dataset.countOther || `${placeholderOpen} count ${placeholderClose} items`,
        removeItem: root.dataset.removeLabel || 'Remove __TITLE__',
        decrease: root.dataset.decreaseLabel || 'Decrease quantity',
        increase: root.dataset.increaseLabel || 'Increase quantity',
        error: root.dataset.errorLabel || 'Something went wrong. Try again.',
        removeText: root.dataset.removeText || 'Remove',
      };

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onCartUpdated = this.onCartUpdated.bind(this);
      this.onCartOpen = this.onCartOpen.bind(this);
      this.onCartClose = this.onCartClose.bind(this);

      this.root.addEventListener('click', this.onDocumentClick);
      document.addEventListener('click', this.onOpenClick.bind(this));
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('cart:updated', this.onCartUpdated);
      document.addEventListener('cart:open', this.onCartOpen);
      document.addEventListener('cart:close', this.onCartClose);

      this.syncBadges(this.getInitialCount());
    }

    getInitialCount() {
      const badge = document.querySelector('[data-cart-count]');
      if (!badge) return 0;
      return Number(badge.dataset.count || badge.textContent.trim()) || 0;
    }

    onOpenClick(event) {
      const trigger = event.target.closest('[data-cart-drawer-open]');
      if (!trigger) return;

      event.preventDefault();
      this.open();
    }

    formatMoney(cents) {
      const value = (Number(cents) || 0) / 100;
      const amount = value.toFixed(2);
      const amountNoDecimals = String(Math.round(value));
      const amountWithComma = amount.replace('.', ',');

      return this.moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    imageUrl(src, width = 240) {
      if (!src) return '';
      if (src.startsWith('//')) return `https:${src}`;
      if (src.includes('{width}')) return src.replace('{width}', String(width));
      return src;
    }

    itemCountLabel(count) {
      if (count === 1) return this.strings.countOne;
      return this.strings.countOther.replace(/\{\{\s*count\s*\}\}/g, String(count));
    }

    open() {
      if (this.isOpen) return;

      this.lastFocused = document.activeElement;
      this.root.hidden = false;
      requestAnimationFrame(() => {
        this.root.classList.add('is-open');
      });
      document.body.classList.add('cart-drawer-open');
      this.isOpen = true;
      this.setExpanded(true);

      window.setTimeout(() => {
        this.panel?.focus();
      }, 40);
    }

    close() {
      if (!this.isOpen) return;

      this.root.classList.remove('is-open');
      document.body.classList.remove('cart-drawer-open');
      this.isOpen = false;
      this.setExpanded(false);

      window.setTimeout(() => {
        if (!this.isOpen) this.root.hidden = true;
      }, 340);

      if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
        this.lastFocused.focus();
      }
    }

    setExpanded(isExpanded) {
      document.querySelectorAll('[data-cart-drawer-open]').forEach((button) => {
        button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    }

    onCartOpen() {
      this.open();
    }

    onCartClose() {
      this.close();
    }

    onCartUpdated(event) {
      const cart = event.detail?.cart;
      if (!cart) return;

      this.render(cart);
      this.syncBadges(cart.item_count);

      if (event.detail?.open) {
        this.open();
      }
    }

    syncBadges(count) {
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.textContent = String(count);
        badge.hidden = count < 1;
        badge.setAttribute('data-count', String(count));
      });

      document.querySelectorAll('[data-cart-icon]').forEach((button) => {
        button.setAttribute('aria-label', this.itemCountLabel(count));
      });
    }

    showStatus(message, isError = false) {
      if (!this.statusEl || !message) return;

      this.statusEl.hidden = false;
      this.statusEl.textContent = message;
      this.statusEl.classList.toggle('is-error', isError);

      window.clearTimeout(this.statusTimer);
      this.statusTimer = window.setTimeout(() => {
        this.statusEl.hidden = true;
      }, 2400);
    }

    onDocumentClick(event) {
      const closeTrigger = event.target.closest('[data-cart-drawer-close]');
      if (closeTrigger) {
        event.preventDefault();
        this.close();
        return;
      }

      const continueLink = event.target.closest('[data-cart-drawer-continue]');
      if (continueLink) {
        this.close();
        return;
      }

      const removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        const line = removeBtn.closest('[data-cart-line]');
        if (line) this.changeQuantity(line.dataset.key, 0, line);
        return;
      }

      const qtyBtn = event.target.closest('[data-cart-qty-change]');
      if (qtyBtn) {
        const line = qtyBtn.closest('[data-cart-line]');
        const valueEl = line?.querySelector('[data-cart-qty-value]');
        if (!line || !valueEl) return;

        const current = Number(valueEl.textContent.trim()) || 0;
        const delta = Number(qtyBtn.dataset.delta) || 0;
        this.changeQuantity(line.dataset.key, Math.max(0, current + delta), line);
      }
    }

    onKeydown(event) {
      if (!this.isOpen) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab' || !this.panel) return;

      const focusables = this.panel.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
      const list = Array.from(focusables).filter((el) => !el.hasAttribute('hidden') && el.offsetParent !== null);
      if (!list.length) return;

      const first = list[0];
      const last = list[list.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    async changeQuantity(key, quantity, lineEl) {
      if (!key) return;

      lineEl?.classList.add('is-updating');

      try {
        const response = await fetch(`${this.routesRoot}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: key, quantity }),
        });

        const cart = await response.json();

        if (!response.ok) {
          throw new Error(cart?.description || cart?.message || this.strings.error);
        }

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart, open: true },
          })
        );
      } catch (error) {
        this.showStatus(this.strings.error, true);
        lineEl?.classList.remove('is-updating');
      }
    }

    render(cart) {
      const items = cart.items || [];
      const count = cart.item_count || 0;

      if (this.countEl) {
        this.countEl.textContent = this.itemCountLabel(count);
      }

      if (this.subtotalEl) {
        this.subtotalEl.textContent = this.formatMoney(cart.total_price);
      }

      this.emptyEl?.classList.toggle('is-hidden', count > 0);
      this.itemsEl?.classList.toggle('is-hidden', count === 0);
      this.footerEl?.classList.toggle('is-hidden', count === 0);

      if (!this.itemsEl) return;

      if (count === 0) {
        this.itemsEl.innerHTML = '';
        return;
      }

      this.itemsEl.innerHTML = items
        .map((item) => {
          const image = this.imageUrl(item.image, 240);
          const variant =
            item.variant_title && item.variant_title !== 'Default Title'
              ? `<p class="cart-drawer__item-variant">${this.escape(item.variant_title)}</p>`
              : '';
          const plan = item.selling_plan_allocation?.selling_plan?.name
            ? `<p class="cart-drawer__item-plan">${this.escape(item.selling_plan_allocation.selling_plan.name)}</p>`
            : '';
          const media = image
            ? `<img class="cart-drawer__item-image" src="${image}" alt="" width="72" height="72" loading="lazy">`
            : `<span class="cart-drawer__item-placeholder" aria-hidden="true"></span>`;

          return `
            <li class="cart-drawer__item" data-cart-line data-key="${this.escape(item.key)}">
              <a class="cart-drawer__item-media" href="${this.escape(item.url)}">${media}</a>
              <div class="cart-drawer__item-content">
                <div class="cart-drawer__item-top">
                  <a class="cart-drawer__item-title" href="${this.escape(item.url)}">${this.escape(item.product_title)}</a>
                  <p class="cart-drawer__item-price">${this.formatMoney(item.final_line_price)}</p>
                </div>
                ${variant}
                ${plan}
                <div class="cart-drawer__item-actions">
                  <div class="cart-drawer__qty" data-cart-qty>
                    <button type="button" class="cart-drawer__qty-btn" data-cart-qty-change data-delta="-1" aria-label="${this.escape(this.strings.decrease)}">−</button>
                    <span class="cart-drawer__qty-value" data-cart-qty-value aria-live="polite">${item.quantity}</span>
                    <button type="button" class="cart-drawer__qty-btn" data-cart-qty-change data-delta="1" aria-label="${this.escape(this.strings.increase)}">+</button>
                  </div>
                  <button type="button" class="cart-drawer__remove" data-cart-remove aria-label="${this.escape(
                    this.strings.removeItem.replace('__TITLE__', item.product_title)
                  )}">${this.escape(this.strings.removeText)}</button>
                </div>
              </div>
            </li>
          `;
        })
        .join('');
    }

    escape(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
  }

  function initCartDrawer() {
    const root = document.querySelector('[data-cart-drawer]');
    if (!root || root.dataset.cartDrawerReady === 'true') return;

    root.dataset.cartDrawerReady = 'true';
    window.BadrockCartDrawer = new CartDrawer(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer, { once: true });
  } else {
    initCartDrawer();
  }

  document.addEventListener('shopify:section:load', initCartDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-redirect-body"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-lp-redirect]');
    if (!root) return;
    const target = root.getAttribute('data-lp-redirect');
    if (target) window.location.replace(target);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smooth-scroll"] && !Shopify.designMode) return;
  try {
    (function () {
      const configEl = document.getElementById('smooth-scroll-config');
      if (!configEl) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const ease = Number(configEl.dataset.ease || 8) / 100;
      const POINTER_FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      const PREVENT_SELECTOR = [
        '[data-smooth-scroll-prevent]',
        '.real-savings__table-wrap',
        '.comparative-table__scroll',
        '.members__carousel-viewport',
        '.announcement-bar__track',
        '.pricing__gallery-thumbs',
        '.header__menu',
      ].join(', ');

      function isPrevented(node) {
        return Boolean(node && node.closest(PREVENT_SELECTOR));
      }

      function headerOffset() {
        const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        const value = parseFloat(raw);
        return Number.isFinite(value) ? value : 0;
      }

      function maxScrollY() {
        return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      }

      let current = window.scrollY;
      let target = window.scrollY;
      let rafId = null;

      function clampTarget() {
        target = Math.max(0, Math.min(target, maxScrollY()));
      }

      function applyScroll(y) {
        window.scrollTo(0, y);
      }

      function loop() {
        const diff = target - current;

        if (Math.abs(diff) < 0.5) {
          current = target;
          applyScroll(current);
          rafId = null;
          return;
        }

        current += diff * ease;
        applyScroll(current);
        rafId = requestAnimationFrame(loop);
      }

      function start() {
        if (!rafId) rafId = requestAnimationFrame(loop);
      }

      function scrollTo(y, immediate) {
        target = y;
        clampTarget();

        if (immediate) {
          current = target;
          applyScroll(current);
          if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = null;
          }
          return;
        }

        start();
      }

      function syncFromNative() {
        current = window.scrollY;
        target = window.scrollY;
      }

      if (!POINTER_FINE) {
        document.documentElement.style.scrollBehavior = 'smooth';
      }

      document.addEventListener(
        'click',
        function (event) {
          const link = event.target.closest('a[href^="#"]');
          if (!link || isPrevented(link)) return;

          const hash = link.getAttribute('href');
          if (!hash || hash === '#') return;

          const section = document.querySelector(hash);
          if (!section) return;

          event.preventDefault();

          const top = section.getBoundingClientRect().top + window.scrollY - headerOffset();

          if (POINTER_FINE) {
            scrollTo(top);
          } else {
            window.scrollTo({ top: top, behavior: 'smooth' });
          }

          history.pushState(null, '', hash);
        },
        true
      );

      if (POINTER_FINE) {
        window.addEventListener(
          'wheel',
          function (event) {
            if (isPrevented(event.target)) return;

            event.preventDefault();
            target += event.deltaY;
            clampTarget();
            start();
          },
          { passive: false }
        );

        window.addEventListener(
          'keydown',
          function (event) {
            if (isPrevented(event.target)) return;

            const active = document.activeElement;
            if (
              active &&
              (active.isContentEditable ||
                active.tagName === 'INPUT' ||
                active.tagName === 'TEXTAREA' ||
                active.tagName === 'SELECT')
            ) {
              return;
            }

            let delta = 0;
            const step = window.innerHeight * 0.85;

            switch (event.key) {
              case 'ArrowDown':
                delta = 80;
                break;
              case 'ArrowUp':
                delta = -80;
                break;
              case 'PageDown':
              case ' ':
                delta = step;
                break;
              case 'PageUp':
                delta = -step;
                break;
              case 'Home':
                scrollTo(0);
                event.preventDefault();
                return;
              case 'End':
                scrollTo(maxScrollY());
                event.preventDefault();
                return;
              default:
                return;
            }

            event.preventDefault();
            target += delta;
            clampTarget();
            start();
          },
          { passive: false }
        );

        window.addEventListener('resize', syncFromNative, { passive: true });
        window.addEventListener('scroll', function () {
          if (!rafId) syncFromNative();
        }, { passive: true });
      }
    })();
  } catch(e) { console.error(e); }
})();

})();
